import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "submit",
    class: "c-button",
    disabled: _ctx.isPending || _ctx.disabled
  }, [
    _createVNode(_Transition, {
      mode: "out-in",
      "enter-active-class": _ctx.enterAnimation,
      "leave-active-class": _ctx.leaveAnimation
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("span", {
          key: _ctx.isPending,
          class: "flex justify-center items-center",
          role: "status"
        }, _toDisplayString(_ctx.isPending ? _ctx.confirmationText : _ctx.text), 1))
      ]),
      _: 1
    }, 8, ["enter-active-class", "leave-active-class"])
  ], 8, _hoisted_1))
}